import { useEffect, useState } from 'react';

// Tailwind's md breakpoint
const MD_BREAKPOINT = 768;

/** True below `breakpoint` (Tailwind's md by default). */
const useIsSmallScreen = (breakpoint: number = MD_BREAKPOINT): boolean => {
  const [isSmall, setIsSmall] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const handler = () => setIsSmall(mql.matches);
    setIsSmall(mql.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [breakpoint]);

  return isSmall;
};

export default useIsSmallScreen;
